// extracted by mini-css-extract-plugin
export default {"root":"FiltersList_root__-qR0q","row":"FiltersList_row__Sw2Is","filterName":"FiltersList_filterName__G27WH","filterValue":"FiltersList_filterValue__eLk1U"};